// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'
import store from './store'

import loading from './api/loading'
Vue.use(loading)

/* axios */
import axios from 'axios'
console.log(process.env)
//axios.defaults.baseURL = 'https://web-test.peets.cn/peets/api/v1'
axios.defaults.baseURL = 'https://www.peets.cn/peets/api/v1'
axios.interceptors.request.use(function (config) {
  // 在这里调用 显示loading方法
  vm.$showLoading()
  return config
}, function (error) {
  vm.$hideLoading()
  // 在请求出错调用 关闭loading方法

  return Promise.reject(error)
})
// 响应拦截
axios.interceptors.response.use(function (response) {
  // 在这里调用 关闭loading方法
  vm.$hideLoading()
  return response
}, function (error) {
  // 在这里调用 关闭loading方法
  vm.$hideLoading()
  return Promise.reject(error)
})

Vue.prototype.$http = axios

/* swiper */
import 'swiper/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'

/*elementui */
import { Input, Select, Option, Scrollbar, Carousel, CarouselItem, Message, Pagination } from 'element-ui';

Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Scrollbar)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Pagination)
Vue.prototype.$message = Message


import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

import videoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
Vue.use(videoPlayer);

/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name, Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name, Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name, GoTop)

var _hmt = _hmt || [];
window._hmt = _hmt;
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?adad54273eb45fc5ce4e78620a342f70";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();


Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath]);
    }
  }
  next();
});


const vm = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js